module.exports = __webpack_public_path__ + "static/img/UY@2x.b371b69d.jpg";